import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.GettingStartedPage.WorkflowSetup', {
    title: 'Set up your first workflow',
    description:
        'Workflows direct documents to the right approvers.{br}Each document type — bills, purchase orders, credit notes, and sales invoices — has its own workflow.{br}{br}Get started in a few clicks with our quick setup wizard!',
    descriptionStandalone:
        'Workflows direct documents to the right approvers.{br}Adjust a workflow to your needs by establishing approval steps, creating custom fields with specific values, and assigning designated approvers.',
    buttonText: 'Set up workflow',
});
